import i18n from "../../i18n";

export function cartItemsToMap(items = []) {
  const next = {};

  for (const it of items) {
    const id = String(it?.product_id || it?.id || "");
    if (!id) continue;

    next[id] = {
      id,
      product_id: id,
      name: it?.name || i18n.t("chat:fallback_product"),
      price: Number(it?.price ?? 0),
      old_price: it?.old_price != null ? Number(it.old_price) : null,
      qty: Number(it?.qty || 1),
      image_url: it?.image_url || "",
      image_proxy_url: it?.image_proxy_url || "",
    };
  }

  return next;
}

export function buildLoginRequiredMessage() {
  return {
    role: "assistant",
    text: i18n.t("chat:login_required"),
    meta: {
      type: "auth_required",
      action: {
        type: "open_user_menu",
        label: i18n.t("chat:login_action"),
      },
    },
  };
}

export function buildErrorMessage() {
  return {
    role: "assistant",
    text: i18n.t("chat:error_message"),
    meta: { type: "error" },
  };
}